// extracted by mini-css-extract-plugin
module.exports = {"copyableWrapper":"Copyable_copyableWrapper__3T5x_","copyableCode":"Copyable_copyableCode__38gPE"};